export enum QualityControl {
    GoodQuality = "GoodQuality",
    BadQuality = "BadQuality",
}
